"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var events_1 = require('events');
var buffer_1 = require('./buffer');
var ndarray = require('ndarray');
var parseBlockModel_1 = require('./parseBlockModel');
var createBuffer = require('gl-buffer');
var createVAO = require('gl-vao');
var cwise = require('cwise');
var assingFilter1 = cwise({
    args: ['array', 'array', 'scalar'],
    body: function (dest, src, f1) {
        var valid = src !== f1;
        dest = valid ? src : 0;
    }
});
var Mesher = (function (_super) {
    __extends(Mesher, _super);
    function Mesher(gl, registry, stitcher, chunkSize) {
        _super.call(this);
        this.gl = gl;
        this.stitcher = stitcher;
        this.registry = registry;
        this.stitcher = stitcher;
        this.isTransparent = undefined;
        this.hasBlockModel = undefined;
        this.chunkSize = chunkSize;
        this.solidVoxels = ndarray(new Uint16Array(chunkSize * chunkSize * chunkSize), [
            chunkSize, chunkSize, chunkSize,
        ]);
    }
    Mesher.prototype.createVoxelMesh = function (voxels) {
        var porous = this.splitVoxelArray(voxels);
        var surface = buffer_1.createVoxelMesh(this.gl, this.solidVoxels, this.stitcher.voxelSideTextureIDs, this.stitcher.voxelSideTextureSizes);
        return {
            surface: surface,
            porous: porous,
        };
    };
    Mesher.prototype.createObjectVao = function (gl, voxels, palette, pad) {
        return buffer_1.createObjectVao(gl, voxels, palette, pad);
    };
    Mesher.prototype.createVoxelObjectVao = function (voxels) {
        // TODO: Support porous
        // const porous = this.splitVoxelArray(matrix);
        var surface = buffer_1.createVoxelMesh(this.gl, voxels, this.stitcher.voxelSideTextureIDs, this.stitcher.voxelSideTextureSizes);
        return surface;
    };
    // mesh custom voxel
    Mesher.prototype.meshCustomBlock = function (value, x, y, z) {
        var _this = this;
        var blockModel = this.registry.blockProps[value].blockModel;
        // parse JSON to vertices and UV
        var model = parseBlockModel_1.default(blockModel, function (name) { return _this.stitcher.getTextureUV(name); }, // only available when textures are ready
        x, y, z);
        return model;
    };
    ;
    // populates solidVoxels array, returns porousMesh
    Mesher.prototype.splitVoxelArray = function (voxels) {
        if (!this.isTransparent) {
            // cache list of transparent voxels TODO: refresh cache when changes
            this.isTransparent = this.registry.getBlockPropsAll('transparent');
            this.isTransparent.unshift(true); // air (0) is transparent
        }
        if (!this.hasBlockModel) {
            this.hasBlockModel = this.registry.getBlockPropsAll('blockModel');
            this.hasBlockModel.unshift(undefined);
        }
        // phase 1: solid voxels = opaque, transparent (terrain blocks, glass, greedily meshed)
        var solidVoxels = this.solidVoxels;
        var isTransparent = this.isTransparent;
        // TODO: Remove hard coded filter value 1
        // ops.assign(solidVoxels, voxels);
        assingFilter1(solidVoxels, voxels, 1);
        // phase 2: porous voxels = translucent, custom block models (stained glass, slabs, stairs)
        var porousMeshes = this.porousMeshes = [];
        var vertices = [];
        var uv = [];
        for (var i = 0, len = solidVoxels.data.length; i < len; ++i) {
            var value = solidVoxels.data[i];
            if (!value)
                continue;
            if (this.hasBlockModel[value]) {
                solidVoxels.data[i] = 0;
                // extract coordinate from ndarray index (sorry)
                var o = i;
                var z = (o % this.chunkSize);
                o = Math.floor(o / this.chunkSize);
                var y = (o % this.chunkSize);
                o = Math.floor(o / this.chunkSize);
                var x = o;
                // accumulate mesh vertices and uv
                var model = this.meshCustomBlock(value, x, y, z);
                vertices = vertices.concat(model.vertices);
                uv = uv.concat(model.uv);
            }
            else if (!isTransparent[value]) {
                solidVoxels.data[i] = value | (1 << 15); // opaque bit
            }
        }
        // load combined porous mesh into GL
        var verticesBuf = createBuffer(this.gl, new Float32Array(vertices));
        var uvBuf = createBuffer(this.gl, new Float32Array(uv));
        var porousMesh = createVAO(this.gl, [
            {
                buffer: verticesBuf,
                size: 3
            },
            {
                buffer: uvBuf,
                size: 2
            },
        ]);
        porousMesh.length = vertices.length / 3;
        return porousMesh;
    };
    ;
    return Mesher;
}(events_1.EventEmitter));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Mesher;
//# sourceMappingURL=Mesher.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/Mesher/Mesher.js
 ** module id = 909
 ** module chunks = 0
 **/